/**
 * Replaces the language prefix in a URL with the given locale.
 *
 * @example
 * replaceLanguageInHref('/nl-be/blog/post-x', 'de') => '/de/blog/post-x'
 */
export function replaceLanguageInHref(href: string, locale: string): string {
  // Match patterns like "/en/", "/nl-be/", possibly without leading slash
  return href.replace(/^\/?([a-z]{2}(?:-[a-z]{2})?)\//i, `/${locale}/`);
}
